import type { Action } from './Action';
import type { Actor } from './Actor';
import type { Predicate } from './predicates';
import type { Resource } from './Resource';

export interface Rule<TResource extends Resource> {
  name: string;
  actions: readonly Action[];
  appliesTo: Predicate<TResource>;
}

export interface AccessRequest<TResource extends Resource> {
  actor: Actor;
  resource: TResource;
  action: Action;
}

export const evaluateRules = <TResource extends Resource>(
  rules: readonly Rule<TResource>[],
  request: AccessRequest<TResource>
): boolean =>
  rules.some(
    rule =>
      rule.actions.includes(request.action) &&
      rule.appliesTo(request.actor, request.resource)
  );
